import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import asset from '../../../../../images/asset-management.jpeg';
import legend from '../../../../../images/services/epc/260_398992222.jpg';
import solar from '../../../../../images/services/epc/renewable/262_1_1728639280.jpg';
import wind from '../../../../../images/services/epc/renewable/262_2_1564602832.jpg';


import '../../../../../styles/mainItem.css'

const AllRenewablePower = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='main-page'>
            <Image src={legend} fluid className="mainItemPage-img" />
            <div className='sub-items'>
                <Container>
                    <h1 className='mb-4'>Renewable Power Plants</h1>
                    <hr className='mb-4' />
                    <Row className='justify-content-md-start'>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/epc-services/renewable-power-plants/solar-power-plant" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Solar Power Plant </p>
                                    <div className='card-image-frame'>
                                        <Image src={solar} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/epc-services/renewable-power-plants/wind-power-plant" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Wind Power Plant </p>
                                    <div className='card-image-frame'>
                                        <Image src={wind} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default AllRenewablePower